import { type IPatient } from 'features/Patients/interfaces/IPatient'

export const patientsTableColumns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    render: (_: string, record: IPatient) => (
      <>
        {record.last_name}, {record.first_name}
      </>
    ),
  },
  {
    title: 'Phone',
    dataIndex: 'phone',
    key: 'phone',
  },
  {
    title: 'Language',
    dataIndex: 'language',
    key: 'language',
  },
  {
    title: 'EMR Pid',
    dataIndex: 'pid',
    key: 'pid',
  },
]
